import {
  Container,
  Card,
  Heading,
  useBreakpoint
} from '@leroy-merlin-br/backyard-react'

import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import { SEARCH_MESSAGE, MESSAGE } from './constants'
import * as S from './styled'

interface NoResultsSearchProps {
  isSearch: boolean
}

const NoResultsSearch = ({ isSearch }: NoResultsSearchProps) => {
  const { query } = useAlgoliaContext()

  const { breakpoint } = useBreakpoint() as unknown as { breakpoint: string }

  const { defaultImagePath } = (window as any).env

  const isMobile = ['untilKilo', 'kilo'].includes(breakpoint)

  const titleSize = isMobile ? 'giga' : 'tera'
  const termSize = isMobile ? 'kilo' : 'mega'
  const message = isSearch ? SEARCH_MESSAGE : MESSAGE

  return (
    <S.Wrapper>
      <Container>
        <Card>
          <S.Main>
            <S.Box>
              <S.Image
                src={`${defaultImagePath}/not-found-result.svg`}
                alt="Error Image"
              />
            </S.Box>

            <Heading
              align="center"
              color="n600"
              size={titleSize}
              as="h1"
              noMargin
            >
              {message}
            </Heading>

            {isSearch && (
              <S.TermWrapper>
                <Heading
                  align="center"
                  color="n600"
                  size={termSize}
                  as="h2"
                  noMargin
                >
                  {`"${query}"`}
                </Heading>
              </S.TermWrapper>
            )}
          </S.Main>
        </Card>
      </Container>
    </S.Wrapper>
  )
}

export default NoResultsSearch
